import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const FROM_INVITATION_KEY = 'fromInvitation';

const InvitationLanding = () => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Mark the session so the dashboard's PendingInvitationsModal knows the user
    // arrived from an invitation email — survives the sign-in redirect chain.
    sessionStorage.setItem(FROM_INVITATION_KEY, '1');

    if (loading) return;
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/signin', { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
      <div className="text-center space-y-3">
        <div className="mx-auto w-12 h-12 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
          <svg className="animate-spin w-6 h-6 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
        <p className="text-sm font-medium text-gray-700 dark:text-gray-200">Opening your workspace invitation…</p>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          {isAuthenticated ? 'Redirecting to your dashboard' : 'Please sign in to continue'}
        </p>
      </div>
    </div>
  );
};

export default InvitationLanding;
